import React from 'react'
import styled from 'styled-components'
import AvatarPlaceholder from '../common/icons/AvatarPlaceholder'
import administratorType from '../common/types/administratorType'

const AdminContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 5rem;
  margin-bottom: 30px;

`
const AdminName = styled.div`
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  font-family: 'Open Sans' sans-serif;
`
const Link = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #56565a;
  &:hover {
    text-decoration: none;
    color: #56565a;
  }
  &:visited {
    text-decoration: none;
    color: #56565a;
  }
`
const AdminCircle = ({ admin: { name, link } }) => (
  <AdminContainer>
    <Link href={link}>
      <AvatarPlaceholder />
      <AdminName>{name}</AdminName>
    </Link>
  </AdminContainer>
)

AdminCircle.propTypes = {
  admin: administratorType
}

export default AdminCircle
